var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tk-container',{attrs:{"status":_vm.status}},[_c('div',{staticClass:"px-15 pt-15 pb-10",attrs:{"slot":"header"},slot:"header"},[_c('global-back')],1),_c('div',{staticClass:"p-x-15 pb-15"},[_c('div',{staticClass:"custom-html",domProps:{"innerHTML":_vm._s(_vm.detail)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }